import {PremiumChangeDueToExpiryOfSupplementBenefit as PremiumChangeDueToExpiryOfSupplementalBenefitLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {toMoneyValue} from 'Shared/utilities/FormatMoney';

type PremiumChangeDueToExpiryOfSupplementalBenefitProps = {
  premiumChangeDueToExpiryOfSupplementalBenefitLetter: PremiumChangeDueToExpiryOfSupplementalBenefitLetter;
};

const PremiumChangeDueToExpiryOfSupplementalBenefit = (props: PremiumChangeDueToExpiryOfSupplementalBenefitProps) => {
  return (
    <>
      <CardField
        name="Date"
        value={toFormattedDateAsUTC(props.premiumChangeDueToExpiryOfSupplementalBenefitLetter.date)}
      />
      <CardField
        name="Effective Date"
        value={toFormattedDateAsUTC(props.premiumChangeDueToExpiryOfSupplementalBenefitLetter.effectiveDate)}
      />
      <CardField
        name="New Premium"
        value={toMoneyValue(props.premiumChangeDueToExpiryOfSupplementalBenefitLetter.newPremium)}
      />
      <CardField name="Agent Number" value={props.premiumChangeDueToExpiryOfSupplementalBenefitLetter.agentNumber} />
      <CardField name="Insured Name" value={props.premiumChangeDueToExpiryOfSupplementalBenefitLetter.insuredName} />
      <CardField name="Owner Name" value={props.premiumChangeDueToExpiryOfSupplementalBenefitLetter.ownerName} />
      <CardField
        name="Owner Address"
        value={props.premiumChangeDueToExpiryOfSupplementalBenefitLetter.ownerAddress!.fullAddress}
      />
      <CardField name="Policy Number" value={props.premiumChangeDueToExpiryOfSupplementalBenefitLetter.policyNumber} />
    </>
  );
};

export default PremiumChangeDueToExpiryOfSupplementalBenefit;
